import { services } from "@/data/content";

export const Services = () => {
  return (
    <section id="palvelut" className="py-16 sm:py-24 bg-[#FDFBF7]">
      <div className="max-w-6xl mx-auto px-6 sm:px-8">
        <div className="max-w-2xl">
          <span className="text-base font-bold text-[#245037] uppercase tracking-wide">
            Palvelut
          </span>
          <h2 className="mt-3 text-3xl sm:text-4xl font-bold tracking-tight text-[#1C1917]">
            Apua kaikkiin arjen digipulmiin
          </h2>
          <p className="mt-4 text-lg sm:text-xl leading-relaxed text-[#44403C]">
            Olipa kyseessä laite, sovellus tai turvallinen verkossa asiointi –
            autan sinua kärsivällisesti ja selkeästi.
          </p>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {services.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={i}
                data-testid={`service-card-${i}`}
                className="bg-white rounded-2xl p-8 shadow-sm border border-[#E8E2D5] hover:shadow-md hover:-translate-y-1 transition-all"
              >
                <div className="w-14 h-14 rounded-xl bg-[#245037]/10 flex items-center justify-center mb-5">
                  <Icon strokeWidth={2.5} className="w-7 h-7 text-[#245037]" />
                </div>
                <h3 className="text-xl font-bold text-[#1C1917]">{s.title}</h3>
                <p className="mt-3 text-base leading-relaxed text-[#44403C]">{s.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
